import React from 'react';

import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../components/BaseVideoAnalyticsDetails';
import type { AnalyticDetailsEvent } from '../types';

type BagEvent = AnalyticDetailsEvent & {
  event: AnalyticDetailsEvent['event'] & {
    overview?: AnalyticDetailsEvent['event']['overview'] & {
      detection?: Record<string, unknown>;
    };
  };
};

export function BagDetails({ event }: { event: BagEvent }): React.JSX.Element {
  const { t } = useTranslation();
  const detection = event.event?.overview?.detection;

  return (
    <BaseVideoAnalyticsDetails
      detections={detection ? [detection] : []}
      detectionSettingsLabel={t('videoAnalytics:bagAnalyticDetails.workspace.detection switch.label')}
      detectionType="bbox"
      event={event}
      title={t('videoAnalytics:bagAnalyticDetails.workspace.title')}
    />
  );
}
